import { Cpu, Download, ShieldCheck, AlertTriangle, Loader2 } from "lucide-react";

export const AISetup = ({ status, progress, progressText, onStart }) => {
  if (status === "checking")
    return (
      <div className="flex-1 grid place-items-center" data-testid="ai-checking">
        <Loader2 className="w-6 h-6 animate-spin text-emerald-600" />
      </div>
    );

  if (status === "unsupported")
    return (
      <div className="flex-1 p-6 flex flex-col items-center justify-center text-center gap-3" data-testid="ai-unsupported">
        <AlertTriangle className="w-10 h-10 text-amber-500" />
        <p className="font-display font-bold text-emerald-950">Navigateur non compatible</p>
        <p className="text-sm text-slate-600">
          L'assistant fonctionne directement sur votre appareil. Il nécessite un navigateur récent
          compatible WebGPU : <strong>Chrome</strong> ou <strong>Edge</strong> sur ordinateur.
        </p>
      </div>
    );

  if (status === "loading")
    return (
      <div className="flex-1 p-6 flex flex-col justify-center gap-4" data-testid="ai-loading">
        <Download className="w-9 h-9 text-emerald-600 animate-bounce mx-auto" />
        <p className="text-center font-semibold text-emerald-950">Préparation de l'IA sur votre appareil…</p>
        <div className="h-2.5 rounded-full bg-emerald-100 overflow-hidden">
          <div
            data-testid="ai-progress-bar"
            className="h-full bg-emerald-600 transition-[width] duration-300"
            style={{ width: `${Math.round(progress * 100)}%` }}
          />
        </div>
        <p className="text-xs text-slate-500 text-center" data-testid="ai-progress-text">
          {Math.round(progress * 100)} % — {progressText}
        </p>
        <p className="text-xs text-slate-400 text-center">Le téléchargement n'a lieu qu'une seule fois.</p>
      </div>
    );

  return (
    <div className="flex-1 p-6 flex flex-col justify-center gap-4" data-testid="ai-intro">
      <span className="grid place-items-center w-12 h-12 rounded-2xl bg-emerald-100 text-emerald-700 mx-auto">
        <Cpu className="w-6 h-6" />
      </span>
      <p className="text-center font-display font-bold text-emerald-950 text-lg">Une IA 100 % sur votre appareil</p>
      <ul className="text-sm text-slate-600 space-y-2">
        <li className="flex gap-2"><ShieldCheck className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" /> Gratuit, et vos questions ne quittent jamais votre navigateur.</li>
        <li className="flex gap-2"><Download className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" /> Premier lancement : environ 1 Go à télécharger (Wi-Fi conseillé).</li>
        <li className="flex gap-2"><Cpu className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" /> Chrome ou Edge récent requis. Réponses plus simples qu'une grande IA.</li>
      </ul>
      {status === "error" && (
        <p className="text-xs text-rose-600 text-center" data-testid="ai-error">Le chargement a échoué. Vérifiez votre connexion et réessayez.</p>
      )}
      <button
        onClick={onStart}
        data-testid="ai-start-btn"
        className="w-full flex items-center justify-center gap-2 bg-emerald-700 hover:bg-emerald-800 text-white font-semibold py-3 rounded-full transition-colors"
      >
        <Download className="w-4 h-4" /> Activer l'assistant
      </button>
    </div>
  );
};
